<template>
  <header class="">
    <div class="skip-nav">
      <a href="#content">Skip to main content</a>
    </div>
    <router-view name="headerLight"></router-view>
    <router-view name="headerDark"></router-view>
  </header>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {
      navigateToHome() {
        this.$router.push('/');
      }
    }
  }

</script>

<style lang="scss">
  @import '~foundation-sites/scss/foundation.scss';
  @import '../css/settings';
  @import '../css/colors';

  .skip-nav {
    float: left;
    &:focus {
      visibility: visible;
    }
    a {
      position: absolute;
      left: -500px;
      overflow: hidden;

      &:active, &:focus {
        position: absolute;
        top: 1rem;
        left: 1rem;
        overflow: visible;
      }
    }
  }

  .logo-header {
    /*outline: 1px dotted cyan;*/
    height: 100px;
    display: flex;
    -ms-flex-align: center;
    max-width: 64rem;
    margin: 20px auto;
  }

  .navigation-header {
    /*outline: 1px dotted yellow;*/
    -ms-flex-align: center;
    color: $deepSilver;
    font-size: 12px;
    letter-spacing: 1px;
    font-family: "Verlag A", "Verlag B", sans-serif;
    font-style: normal;
    font-weight: 700;
    @include breakpoint(medium) {
      padding-left: 12px;
    }

    ul {
      padding: 0;
      /*margin: 0;*/
      margin: 10px 0 0 0;
      text-align: center;

      @include breakpoint(medium) {
        margin: 0 0 28px 0;
        text-align: left;
      }
    }

    ul li {
      display: inline-block;
      a {
        color: $deepSilver;
        &.active {
          color: $deepHaze;
          text-decoration: none;
        }
      }
    }
    li:after {
      padding: 0 4px;
      color: $deepPewter;
      content: " \005c";
    }
    li:last-child:after {
      background-color: $deepSilver;
      content: none;
    }

    /* resume header */
    .on-resume {
      padding: 0;
      margin: 0;
      font-size: .875rem;
      text-align: center;
      color: $deepPewter;
      letter-spacing: 0.5px;

      @include breakpoint(medium) {
        margin: 0 0 28px 0;
        text-align: left;
      }
      :after {
        color: $deepSilver;
      }
    }

    /* on EXPERIENCE you have a body class for a light color now change the nav color */
    &.on-light {
      ul li {
        display: inline-block;
        a {
          color: $deepPewter;
          &.active {
            color: $deepBlack;
            text-decoration: none;
          }
        }
      }
      li:after {
        padding: 0 4px;
        color: $deepSilver;
        content: " \005c";
      }
      li:last-child:after {
        content: none;
      }
    }

  }



  .logotype {
    /*outline: 1px solid magenta;*/

    span {
      visibility: hidden;
    }

    a {
      // IE11 NEEDS HEIGHT for SVG ?
      height: 62px;
    }

    .logo {
      position: relative;
      max-width: 184px;
      cursor: pointer;

      .logo-front {
        position: absolute;
        bottom: 2px;
        right: 0;
        line-height: 1;
        max-width: 184px;
        z-index: 3;

        &.on-dark {
          fill: $deepHaze;
        }

        &.on-light {
          fill: $deepBlack;
        }

      }
      /*
      .logo-shadow {
        display: none;
        position: absolute;
        bottom: -2px;
        right: 0;
        line-height: 1;
        fill: $deepBlue;
        opacity: 0.7;
        max-width: 184px;
        z-index: 2;
      }
      */
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/Header.vue